<div class="row">

  <div class="col-6"></div>

  <div class="col-3">
    <div class="mb-3">
      <app-dropdown-date
        [initialDate]="startDate"
        title="Start Date"
        (selectOnChangeEvent)="startDateChanged($event)"
      ></app-dropdown-date>
    </div>
  </div>

  <div class="col-3">
    <div class="mb-3">
      <app-dropdown-date
        [initialDate]="endDate"
        title="End Date"
        (selectOnChangeEvent)="endDateChanged($event)"
      ></app-dropdown-date>
    </div>
  </div>

</div>

@if (gotDgProperties) {
  <app-grid-view #gridView
    [apiPath]="dgApiPath"
    [dgActionColumn]="dgActionColumn"
    [dgColumns]="dgColumns"
    [dgPopup]="dgPopup"
    [dgProperties]="dgProperties"
    (addButtonClick)="gridAddButtonClick($event)"
    (contentReady)="onGridContentReady()"
    (editButtonClick)="gridEditButtonClick($event)"
    (rowExpanding)="gridRowExpanding($event)"
  >
    <app-sim-network-event-embedded
      #simNetworkEvent
      [locationLicensed]="locationLicensed"
    ></app-sim-network-event-embedded>
  </app-grid-view>
}
